// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root_QgQJZ","root-fluid":"Container_root-fluid_28Xob"};